import React, {useEffect, useRef, useState} from "react";
import {Button, Col, FormGroup, Input, Label, Row, Spinner} from "reactstrap";
import {FormControl} from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import Select from "react-select";
import {cities} from "../../util/Cities";
import {getSelectedObject} from "../../util/Helper";
import {NotificationManager} from "react-notifications";
import DatePicker from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";

const BasicInfo = (props) => {
  const [basicInfo, setBasicInfo] = useState({});
  const [selectedDate, setSelectedDate] = useState(moment("2010-01-01"));
  const dateInputRef = useRef(null);

  useEffect(() => {
    console.log({...props.basicInfo});
    console.log({...props.candidate});
    setBasicInfo({...props.candidate});
    if (props.candidate.dob) {
      setSelectedDate(props?.candidate?.dob);
    } else {
      console.log(selectedDate);
      const jsDate = selectedDate.toDate();
      setBasicInfo({...basicInfo, dob: jsDate});
      props.setCandidate({...props.candidate, dob: jsDate});
    }
  }, []);

  const isFieldEnabled = (fieldName) =>
      props.basicInfo.fields[fieldName]?.enabled;

  const theLabelName = (fieldName) => props.basicInfo.fields[fieldName]?.label;

  const handleChange = (e) => {
    setBasicInfo({...basicInfo, [e.target.name]: e.target.value});
    if (e.target.name === "email") {
      setBasicInfo({
        ...basicInfo,
        [e.target.name]: e.target.value,
        email_insensitive: e.target.value.toLowerCase(),
      });
    }
  };

  // const handleValidation = () => {
  //   const {
  //     name,
  //     partnerName,
  //     dob,
  //     email,
  //     phone,
  //     altPhone,
  //     currentAddress,
  //     city,
  //     homeTown,
  //     cnic,
  //     gender,
  //     nationality,
  //   } = basicInfo;

  //   // Check if all fields are filled
  //   if (
  //     !name ||
  //     !dob ||
  //     !email ||
  //     !phone ||
  //     !city ||
  //     !cnic ||
  //     !gender ||
  //     !nationality
  //   ) {
  //     return false;
  //   }
  //   if (email) {
  //     if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/)) {
  //       NotificationManager.error("Please enter a valid email address.");
  //       return;
  //     }
  //   }
  //   if (cnic.length !== 13) {
  //     NotificationManager.error("Please enter a valid CNIC.");
  //     return;
  //   }

  //   // All fields are present, continue with further logic
  //   return true;
  // };
  const handleValidation = () => {
    const {
      name,
      partnerName,
      dob,
      email,
      phone,
      altPhone,
      currentAddress,
      city,
      homeTown,
      cnic,
      gender,
      nationality,
    } = basicInfo;

    // Check if all fields are filled
    if (
        (isFieldEnabled("name") && !name) ||
        (isFieldEnabled("dob") && !dob) ||
        (isFieldEnabled("email") && !email) ||
        (isFieldEnabled("phone") && !phone) ||
        (isFieldEnabled("city") && !city) ||
        (isFieldEnabled("cnic") && !cnic) ||
        (isFieldEnabled("gender") && !gender) ||
        (isFieldEnabled("nationality") && !nationality)
    ) {
        // NotificationManager.error("Please fill in all the required fields.");
      return false;
    }

    // Additional validations for specific fields
    if (isFieldEnabled("email") && email) {
      if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/)) {
        NotificationManager.error("Please enter a valid email address.");
        return false;
      }
    }

    if (isFieldEnabled("cnic") && cnic && cnic.length !== 13) {
      NotificationManager.error("Please enter a valid CNIC.");
      return false;
    }

    // All required fields are valid
    return true;
  };

  const handleNext = () => {
    if (handleValidation()) {
      props.setCandidate({...props.candidate, ...basicInfo});

      // props.setProgress(17);
      console.log(props.progress);

      const newProgress = (props.progress || 0) + props.progressIncrement;
      props.setProgress(newProgress);

      props.setStep(2);
      let temp = {...props.isCompleted};
      temp.basicInfo = true;
      props.setIsCompleted(temp);
      console.log(temp);

      props.switchComponent("education");
      props.gotoSlide(1);
    } else {
      NotificationManager.error("Please fill in all the required fields.");
    }
  };
  const handleFinal = async () => {
    if (handleValidation()) {
      let temp = {...props.isCompleted, basicInfo: true};
      props.setIsCompleted(temp);
      const completeData = {...props.candidate, ...basicInfo};
      props.setCandidate(completeData);
      await props.handleSubmit(completeData);
    } else {
      NotificationManager.error("Please fill in all the required fields.");
    }
  };

  return (
      <div className="d-flex justify-content-between">
        <Col className=" px-lg-2 mt-lg-2 pt-lg-2">
          <div className={"text-center"}>
            <h3 className="secondary-heading">
              Please enter your personal information
            </h3>
          </div>

          <Row className="grid-row mt-4">
            {isFieldEnabled("name") && (
                <Col md={12}>
                  <FormGroup>
                    <Label className="float-sm-left ml-3">
                      <strong>
                        {theLabelName("name")} :{" "}
                        <span className={"active-text"}>*</span>
                      </strong>
                    </Label>
                    <FormControl
                        type={"text"}
                        id="Full Name"
                        name={"name"}
                        placeholder={theLabelName("name")}
                        value={basicInfo?.name}
                        className={"input-grey"}
                        onChange={(event) => handleChange(event)}
                    />
                  </FormGroup>
                </Col>
            )}
            {isFieldEnabled("partnerName") && (
                <Col md={12}>
                  <FormGroup>
                    <Label className="float-sm-left ml-3">
                      <strong>
                        {theLabelName("partnerName")} :{" "}
                        {/*<span className={"active-text"}>*</span>*/}
                      </strong>
                    </Label>
                    <FormControl
                        type={"text"}
                        id="partnerName"
                        name={"partnerName"}
                        placeholder={theLabelName("partnerName")}
                        value={basicInfo?.partnerName}
                        className={"input-grey"}
                        onChange={(event) => handleChange(event)}
                    />
                  </FormGroup>
                </Col>
            )}
            {/* </Row> */}

            {/* <Row> */}
            {isFieldEnabled("dob") && (
                <Col md={12}>
                  {/*<FormGroup>*/}
                  <Row>
                    <Label className="float-sm-left ml-3">
                      <strong>
                        {theLabelName("dob")}:{" "}
                        <span className={"active-text"}>*</span>
                      </strong>
                    </Label>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <DatePicker
                          className="input-grey w-100 form-control p-0"
                          value={selectedDate}
                          onChange={(date) => {
                            if (moment.isMoment(date)) {
                              const jsDate = date.toDate(); // Convert Moment object to JavaScript Date object
                              setBasicInfo({...basicInfo, dob: jsDate});
                              setSelectedDate(date);
                            }
                          }}
                          isValidDate={(current) => {
                            // Allow only valid dates or empty input
                            return current.isBefore("2010-01-01", "day");
                          }}
                          closeOnSelect={true}
                          timeFormat={false}
                          dateFormat="DD/MM/YYYY"
                      />
                    </Col>
                  </Row>
                </Col>
            )}
            {isFieldEnabled("email") && (
                <Col md={12}>
                  <FormGroup>
                    <Label className="float-sm-left ml-3">
                      <strong>
                        {theLabelName("email")}{" "}
                        <span className={"active-text"}>*</span>
                      </strong>
                    </Label>
                    <FormControl
                        type={"email"}
                        id="firstName"
                        placeholder={theLabelName("email")}
                        name={"email"}
                        value={basicInfo?.email}
                        onChange={(event) => handleChange(event)}
                        className={"input-grey"}
                    />
                  </FormGroup>
                </Col>
            )}
            {/* </Row> */}

            {/* <Row> */}
            {isFieldEnabled("phone") && (
                <Col md={12}>
                  {/*<FormGroup>*/}
                  <Label className="float-sm-left ml-3">
                    <strong>
                      {theLabelName("phone")} :{" "}
                      <span className={"active-text"}>*</span>
                    </strong>
                  </Label>
                  <br/>
                  {/*<FormControl type={"text"} id="firstName" placeholder="First Name" className={"input-grey"}/>*/}
                  <PhoneInput
                      inputClass={"input-grey-p-0"}
                      inputStyle={{
                        width: "100%",
                        border: "none",
                      }}
                      inputProps={{
                        name: "phone",
                      }}
                      country={"pk"}
                      onChange={(phone) => {
                        setBasicInfo({...basicInfo, phone: phone});
                      }}
                      value={basicInfo?.phone}
                  />
                  {/*</FormGroup>*/}
                </Col>
            )}
            {isFieldEnabled("altPhone") && (
                <Col md={12}>
                  <FormGroup>
                    <Label className="float-sm-left ml-3">
                      <strong>
                        {theLabelName("altPhone")}{" "}
                        {/*<span className={"active-text"}>*</span>*/}
                      </strong>
                    </Label>
                    <br/>
                    <PhoneInput
                        inputClass={"input-grey-p-0 mt-1"}
                        inputStyle={{
                          width: "100%",
                          border: "none",
                        }}
                        inputProps={{
                          name: "altPhone",
                        }}
                        country={"pk"}
                        onChange={(phone) => {
                          setBasicInfo({...basicInfo, altPhone: phone});
                        }}
                        value={basicInfo?.altPhone}
                    />
                  </FormGroup>
                </Col>
            )}
            {/* </Row> */}

            {/* <Row> */}
            {isFieldEnabled("cnic") && (
                <Col md={12}>
                  {/*<FormGroup>*/}
                  {/*    <Label className="float-sm-left ml-3">*/}
                  {/*        <strong>*/}
                  {/*            Current Address : <span className={"active-text"}>*</span>*/}
                  {/*        </strong>*/}
                  {/*    </Label>*/}
                  {/*    <FormControl*/}
                  {/*        type={"text"}*/}
                  {/*        id="firstName"*/}
                  {/*        name={"currentAddress"}*/}
                  {/*        onChange={(event) => handleChange(event)}*/}
                  {/*        placeholder="Current Address"*/}
                  {/*        value={basicInfo?.currentAddress}*/}
                  {/*        className={"input-grey"}*/}
                  {/*    />*/}
                  {/*</FormGroup>*/}
                  <FormGroup>
                    <Label className="float-sm-left ml-3">
                      <strong>
                        {theLabelName("cnic")}{" "}
                        <span className="fs-14">(without dashes)</span> :{" "}
                        <span className={"active-text"}>*</span>
                      </strong>
                    </Label>
                    <FormControl
                        type={"number"}
                        id="firstName"
                        maxLength={13}
                        placeholder={theLabelName("cnic")}
                        name={"cnic"}
                        value={basicInfo?.cnic}
                        onChange={(event) => {
                          if (event.target.value.length <= 13) {
                            handleChange(event);
                          }
                        }}
                        className={"input-grey"}
                    />
                  </FormGroup>
                </Col>
            )}
            {isFieldEnabled("city") && (
                <Col md={12}>
                  <FormGroup>
                    <Row>
                      <Col>
                        <Label className="float-sm-left ml-3">
                          <strong>
                            {theLabelName("city")} :{" "}
                            <span className={"active-text"}>*</span>
                          </strong>
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Select
                            className="react-select primary -border-none text-left input-grey-p-0"
                            classNamePrefix="react-select"
                            options={cities}
                            name="currentCity"
                            value={getSelectedObject(basicInfo?.city, cities)}
                            onChange={(selectedOption) => {
                              setBasicInfo({
                                ...basicInfo,
                                city: selectedOption.value,
                              });
                            }}
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
            )}
            {/* </Row> */}
            {/* <Row> */}
            {isFieldEnabled("homeTown") && (
                <Col md={12}>
                  <FormGroup>
                    <Row>
                      <Col>
                        <Label className="float-sm-left ml-3">
                          <strong>
                            {theLabelName("homeTown")} :{" "}
                            <span className={"active-text"}>*</span>
                          </strong>
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Select
                            className="react-select primary -border-none text-left input-grey-p-0"
                            classNamePrefix="react-select"
                            name="homeTown"
                            options={cities}
                            value={getSelectedObject(basicInfo?.homeTown, cities)}
                            onChange={(selectedOption) => {
                              setBasicInfo({
                                ...basicInfo,
                                homeTown: selectedOption.value,
                              });
                            }}
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
            )}
            {isFieldEnabled("nationality") && (
                <Col md={12}>
                  <FormGroup>
                    <Label className="float-sm-left ml-3">
                      <strong>
                        {theLabelName("nationality")} :{" "}
                        <span className={"active-text"}>*</span>
                      </strong>
                    </Label>
                    <FormControl
                        type={"text"}
                        id="nationality"
                        placeholder={theLabelName("nationality")}
                        name={"nationality"}
                        value={basicInfo?.nationality}
                        onChange={(event) => handleChange(event)}
                        className={"input-grey"}
                    />
                  </FormGroup>
                </Col>
            )}
            {/* </Row> */}
            {/* <Row> */}
            {isFieldEnabled("gender") && (
                <Col md={12}>
                  <FormGroup>
                    <Label className="float-sm-left ml-3">
                      <strong>
                        {theLabelName("gender")} :{" "}
                        <span className={"active-text"}>*</span>
                      </strong>
                    </Label>{" "}
                    <br/>
                    <div className={"d-flex w-100 ml-4 align-baseline"}>
                      <Row>
                        <Col sm={6}>
                          <Label>
                            <Input
                                type={"radio"}
                                name={"gender"}
                                className={"custom-radio-button"}
                                value={"male"}
                                onChange={handleChange}
                                checked={basicInfo.gender === "male"}
                            />
                            <span
                                className={"mt-1"}
                                style={{
                                  fontStyle: "18px",
                                  marginLeft: "5px",
                                }}
                            >
                          <strong>Male</strong>
                        </span>
                          </Label>
                        </Col>
                        <Col sm={6}>
                          <Label>
                            <Input
                                type={"radio"}
                                name={"gender"}
                                className={"custom-radio-button"}
                                value={"female"}
                                onChange={handleChange}
                                checked={basicInfo.gender === "female"}
                            />
                            <span
                                className={"mt-1"}
                                style={{
                                  fontStyle: "18px",
                                  marginLeft: "5px",
                                }}
                            >
                          <strong>Female</strong>
                        </span>
                          </Label>
                        </Col>
                      </Row>
                    </div>
                  </FormGroup>
                </Col>
            )}
            {/* </Row> */}
            {/* <Row> */}
          </Row>
          <Col>
            {/* <Button
              className="beginBtn startButton float-right"
              color=""
              onClick={() => {
                handleNext();
              }}
            >
              <span className="text-white font-weight-normal">Next</span>
            </Button> */}
            <Button
                className="beginBtn startButton float-right"
                color=""
                onClick={(e) => {
                  if (props?.lastComponent) {
                    handleFinal();
                  } else {
                    handleNext();
                  }
                }}
            >
            <span className="text-white font-weight-normal">
              {props.lastComponent ? (
                  <>
                    {props.isLoading ? (
                        <Spinner color="light" size="sm"/>
                    ) : (
                        "Submit"
                    )}
                  </>
              ) : (
                  <>Next</>
              )}
            </span>
            </Button>
          </Col>
        </Col>
      </div>
  );
};

export default BasicInfo;
